import SlideBottomOverlayFanComponent from "./SlideBottomOverlayFanComponent";

export default SlideBottomOverlayFanComponent;
